"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNonStaticParent = useNonStaticParent;
exports.useAbsoluteCenteredPositioning = useAbsoluteCenteredPositioning;

var _react = require("react");

/**
 * Ensures that a statically or non-positioned parent node has relative positioning
 * @param {*} ref - React ref (or any object with .current property that is a DOM node)
 */
function useNonStaticParent(ref, resetParent) {
  (0, _react.useEffect)(function () {
    var parent = ref.current ? ref.current.parentNode : null;

    if (parent) {
      var _window$getComputedSt = window.getComputedStyle(parent),
          position = _window$getComputedSt.position;

      if (!position || position === 'static') {
        parent.style.position = 'relative'; // reset parent position when unmounting

        if (resetParent) return function () {
          if (parent) parent.style.position = position;
        };
      }
    }
  });
}
/**
 * Ensures that a node is absolutely positioned within the center of its parent, taking
 * into account its dimensions
 * @param {*} ref - React ref (or any object with .current property that is a DOM node)
 */


function useAbsoluteCenteredPositioning(ref) {
  (0, _react.useEffect)(function () {
    if (!ref.current) return;
    var node = ref.current; // apply positioning and display styles first

    node.style.position = 'absolute';
    node.style.disply = 'inline-block';
    node.style.left = '50%';
    node.style.top = '50%';
    node.style.textAlign = 'center';
    node.style.visibility = 'hidden'; // calculate marginLeft and marginTop based on the node's dimensions

    var offsetWidth = node.offsetWidth,
        offsetHeight = node.offsetHeight;
    node.style.marginLeft = "-".concat(offsetWidth / 2, "px");
    node.style.marginTop = "-".concat(offsetHeight / 2, "px");
    node.style.visibility = 'visible';
  });
}